import React, { useState } from "react";

export const PALETTE = [
  "#EF4444", "#F97316", "#F59E0B", "#EAB308", "#84CC16", "#22C55E",
  "#10B981", "#14B8A6", "#06B6D4", "#0EA5E9", "#3B82F6", "#6366F1",
  "#8B5CF6", "#A855F7", "#D946EF", "#EC4899", "#F43F5E", "#64748B",
  "#6B7280", "#78716C", "#92400E", "#166534", "#1E3A8A", "#0F172A",
];

export default function ColorPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative inline-flex">
      <button
        type="button"
        data-testid="color-dot"
        onClick={() => setOpen((o) => !o)}
        style={{ background: value || "#64748B" }}
        className="h-4 w-4 rounded-full border border-white/40 shadow"
        title="RENK SEÇ"
      />
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute left-0 top-5 z-50 grid grid-cols-6 gap-1.5 rounded-lg border border-slate-700 bg-slate-900 p-2 shadow-2xl">
            {PALETTE.map((c) => (
              <button
                key={c}
                type="button"
                data-testid={`color-${c}`}
                onClick={() => { onChange(c); setOpen(false); }}
                style={{ background: c }}
                className={`h-5 w-5 rounded-md transition hover:scale-110 ${value === c ? "ring-2 ring-white" : ""}`}
              />
            ))}
          </div>
        </>
      )}
    </span>
  );
}
